<template>
  <div :style="themeStyle">
    <!-- <header-profile></header-profile> -->
      <SectionNavbar
    v-if="isTargetShop"
    :position="210"
    :imgCover="imgCover"
    :baner="false"
  />
    <v-container class="pa-5">
      <v-card class="mx-auto pa-5 mb-5" max-width="400" flat tile>
        <v-card-title class="pr-0">
          <v-avatar size="54px">
            <img v-if="this.items.logo" alt="Avatar" :src="this.items.logo" />
            <img v-else alt="Avatar" src="@/assets/user.png" />
          </v-avatar>
          <p class="text-h6 font-weight-light ml-4 mb-0 pr-0" :style="$isTargetShop ? 'font-weight: bold; font-size: 16px !important padding-right: 0px;'  : ''">{{ this.items.name }}</p>
        </v-card-title>

        <v-card-text  style="margin-bottom: 20px;">
          <div style="display: flex;">
            <p class="mb-0" style="color: #871b12;margin-right:10px;">{{ $t("message.address") }} :</p>
            <p class="mb-0" style="flex: 1"> {{ this.items.Address }}</p>
          </div>
          <div style="display: flex; margin-bottom:20px;">
            <p class="mb-0" style="color: #871b12;margin-right:7px">{{ $t("message.tel") }} :</p>
            <!-- <p class="mb-0">{{ this.items.contactTel }}</p> -->
            <a class="mb-0" :href="'tel:' + this.items.contactTel">{{ this.items.contactTel }}</a>
          </div>
                  <v-divider  class="mb-1"></v-divider>
            <!-- <menu-item icon="store" title="สาขาทั้งหมดของเรา" link="/Mybranch"></menu-item> -->
            <div style="display: flex;justify-content:space-between;" @click="isShow = !isShow">
                  <div class="minwidth" style="padding-top: 5px;padding-left: 0px;font-size: 15px;line-height: 24px;color: #323232;">
                    {{ $t("message.allBranch") }}
                  </div>
                  <v-icon  v-if="isShow" style="padding-right: 10px;" size="30px">
                      mdi-menu-up-outline
                  </v-icon>
                   <v-icon v-if="isShow === false" style="padding-right: 10px;" size="30px">
                      mdi-menu-down-outline
                  </v-icon>
            </div>
            <div v-if="isShow" :class="(isShow === true) ? 'animation' : 'test'">
                <div v-for="(item,i) in items2" :key="i">
                  <p style="font-weight: 800;font-size: 16px;line-height: 24px;color: #323232;margin-bottom:10px;" class="bold">{{item.masBranchName}}</p>
                <div style="margin-bottom:15px;">
                  <img :src ="$images.timeChubb" alt="branchPicture" style="width:20px;height:20px;vertical-align:middle;" v-if="$isTargetShop()"/>
                  <v-icon size="20px" color="#9D9D9D" v-else>
                      mdi-alarm
                  </v-icon> <span style="font-size: 14px;"> {{item.timeOC}} </span>
                </div>
                <div style="margin-bottom:15px;">
                    <img :src ="$images.phoneChubb" alt="branchPicture" style="width:20px;height:20px;vertical-align:middle;" v-if="$isTargetShop()"/>
                  <v-icon size="20px" color="#9D9D9D" v-else>
                      mdi-phone
                  </v-icon> <a class="mb-0" :href="'tel:' + item.tel" style="font-size: 14px;">{{item.tel}}</a>
                </div>
                <div style="margin-bottom:15px;">
                    <img :src ="$images.mapChubb" alt="branchPicture" style="width:20px;height:20px;vertical-align:middle;" v-if="$isTargetShop()"/>
                  <v-icon size="20px" color="#9D9D9D" v-else>
                      mdi-map-marker
                  </v-icon>
                  <a :href="item.map" style="font-size: 14px;">{{ $t("message.map") }}</a>
                </div>
                <!-- <v-divider></v-divider> -->
                </div>
              </div>

          <!-- <p class="mb-2" style="color: #871b12">สาขาทั้งหมด </p>
          <v-card class="mb-2" style="padding:10px;" v-for="(item,i) in items2" :key="i">
          <p class="mb-0">- {{item.masBranchName}}</p>
          <p class="mb-0">เบอร์ติดต่อ : {{item.tel}}</p>
          <div style="display: flex">
          <p class="mb-0">แผนที่ :</p>
          <a :href="item.map">Click <v-icon size="18px" color="#1778F2">
            mdi-cursor-default-click
          </v-icon></a>
          </div>
          </v-card> -->
        </v-card-text>
             <v-divider class="mt-2"></v-divider>
        <div class="px-1" style="display: flex; flex-wrap: nowrap; margin-bottom: 10px">
           <p class="mb-0" style="color: #871b12; font-size: 14px; margin-right: 10px; width: fit-content; white-space: nowrap;min-width: fit-content;">Website :</p>
           <a :href="this.items.WebsiteShop" class="mb-0 " style="font-size: 14px;word-break: break-word;">{{this.items.WebsiteShop}}</a>
        </div>
       <div  style="display: flex">
        <div style="display: flex"  v-if="this.items.FacebookShop">
          <a :href="this.items.FacebookShop" class="mb-0" style="margin-right: 5px; margin-left: 5px;"> <v-icon  :color="'blue'" size="32px">
            mdi-facebook
          </v-icon></a>
        </div>
        <div style="display: flex" v-if="this.items.InstagramShop">
          <a :href="this.items.InstagramShop" class="mb-0" style="margin-right: 5px; margin-left: 5px;">
            <v-icon  :color="'#000'" size="32px">
            mdi-instagram
          </v-icon>
          </a>
        </div>
        <div style="display: flex" v-if="this.items.TwitterShop">
          <a :href="this.items.TwitterShop" style="margin-right: 5px; margin-left: 5px;">
              <v-icon  :color="'#1DA1F2'" size="32px">
            mdi-twitter
          </v-icon>
          </a>
        </div>
         <div style="display: flex" v-if="this.items.YoutuberShop">
          <a :href="this.items.YoutuberShop" style="margin-right: 5px; margin-left: 5px;">
              <v-icon  :color="'red'" size="32px">
            mdi-youtube
          </v-icon>
          </a>
        </div>
        <div style="display: flex" v-if="this.items.LineShop">
          <a :href="this.items.LineShop" style="margin-right: 5px; margin-left: 5px;padding-top:2px">
             <v-icon class="iconify" data-icon="arcticons:line" :color="'#00C300'"></v-icon>
          </a>
        </div>
        <div style="display: flex" v-if="this.items.TikTokShop">
          <a :href="this.items.TikTokShop" style="margin-right: 5px; margin-left: 5px;padding-top:2px">
               <v-icon class="iconify" data-icon="cib:tiktok" :color="'#000000'"></v-icon>
          </a>
        </div>
       </div>
      </v-card>
      <!-- <v-divider></v-divider> -->
      <!-- <menu-item icon="logout-variant" title="ออกจากร้าน" link="/MemberShop"></menu-item> -->
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderProfile from '../../HeaderProfile'
import MenuItem from '../../MenuItem'
import SectionNavbar from '@/components/Layouts/SectionNavbar.vue'

export default {
  name: 'AccountMain',
  components: {
    'header-profile': HeaderProfile,
    'menu-item': MenuItem,
    SectionNavbar
  },
  data () {
    return {
      items: [],
      items2: [],
      isShow: false,
      shopname: [],
      member: null,
      profile: null,
      shopId: null,
      imgCover: null
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    this.getOnlyShop()
    this.getBranch()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getOnlyShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/only_shop/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.items = result[0]
          this.shopname = result[0].name
        }
      }
    },
    async getBranch () {
      const result = await this.callBeTaskAPI(
        'get',
        `/master_branch/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.items2 = result
        }
      }
    }
  }
}
</script>
<style scoped>
.minwidth{
  min-width: fit-content;
}
.v-card__title{
  flex-wrap: nowrap !important;
}
p{
  margin-bottom: 0;
}
.slide-down-enter-to,
.slide-down-leave {
  transform-origin: top ;
  animation-name: menu1;
  animation-duration: 200ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  transition: max-height 2s;
}

.slide-down-enter,
.slide-down-leave-to {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;

}
.test{
  transform-origin: bottom ;
    animation-name: menu2;

  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;
    animation-timing-function: ease-in-out;

}
.animation{
  transform-origin: top ;
  animation-name: menu1;
  animation-duration: 200ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}
 @keyframes menu1 {
  0%   { opacity: 0; transform: rotateX(-50deg)}
  100% { opacity: 1; transform: rotateX(0)}
}
.v-sheet.v-card {
    border-radius: 14px;
    background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Account/Main.vue